import { AccountApi } from "../../Types/Generated/LogbookApi/AccountApi"
import { entity } from "./Connection"

export const AccountSubscriptionPlanEntity = entity("AccountSubscriptionPlan", {
  fetch: (client) =>
    new AccountApi(client).account.plans({ params: {} }).call().then((response) => ({
      entities: {
        AccountSubscriptionPlan: response.plans.map(({ plan }) => plan),
        AccountSubscriptionPlanFeature: response.plans.flatMap(({ features }) => features),
        AccountSubscriptionPlanPricing: response.plans.flatMap(({ pricing }) => pricing),
      },
      extras: {
        stripeKey: response.stripeKey,
        appAccountToken: response.appAccountToken,
      },
      authoritative: {
        AccountSubscriptionPlan: {},
        AccountSubscriptionPlanFeature: {},
        AccountSubscriptionPlanPricing: {},
      },
    })),
});
